module.exports = __webpack_public_path__ + "static/img/yinka.05cf34a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/vip/yinka.png
// module id = sh84
// module chunks = 2